import { CONTRACT_STATUSES } from '@weft/types';
import { oz } from '@weft/utils';

export const UpdateContractStatusRequestSchema = oz.object({
  status: oz.enum([CONTRACT_STATUSES.Active, CONTRACT_STATUSES.Inactive]),
}).openapi('UpdateContractStatusRequest');

export type UpdateContractStatusRequestPayload = oz.infer<typeof UpdateContractStatusRequestSchema>;